import { Data } from 'digicon-web-model/data/data';
import { Attribute } from 'digicon-web-model/classes/attribute';

export class DataUtils {
	constructor() {

		this._metaUtils = new MetaUtils();
	}

	setDomain( data ) {
		//data.setDomain( 'http://localhost', '/net-zero/' );
	}

	getAttributeByTypeId( node, type ) {
		let tp = parseInt( type );

		let atts = node && node.attributes ? node.attributes : 
			node && node.getAttributes() ? node.getAttributes() : [];
		let att = atts.filter( att => {
			let attType = typeof att.typeId !== 'undefined' ? att.typeId : 
				typeof att.getTypeId !== 'undefined' ? att.getTypeId() : null;
			return attType === tp;
		} );

		return att.length > 0 ? att[0] : null;
	}

	removeMarks( data ) {
		return this._metaUtils.removeMarks( data );
	}

	clearMetaAttributes( node ) {
		return this._metaUtils.clearMetaAttributes( node );
	}

	async addMetaAttributes( node, def ) {
		return await this._metaUtils.addMetaAttributes( node, def );
	}

	_addMetaAttributes( node, definition ) {
		return this._metaUtils._addMetaAttributes( node, definition );
	}
}

class MetaUtils {
	constructor() {        
		this.__cleanedcache = [];
	}
	removeMarks( data ) {
		return JSON.parse( data.replace( /""/g, '"' ) );
	}

	clearMetaAttributes( node ) {
    
		for ( var i = node.attributes.length - 1; i > -1; i-- ) {
			if( node.attributes[i].typeId === 26 ) node.attributes.splice( i, 1 );
		}

		//cache to avoid recursive cleans
		this.__cleanedcache[ `n${node.id}` ] = node;

		if( node.children && node.children.length > 0 ) {
			for ( let i = node.children.length - 1; i > -1; i-- ) {
				if( typeof this.__cleanedcache[ `n${node.children[i].id}` ] === 'undefined' )
					this.clearMetaAttributes( node.children[i] );
			}
		}
        
		delete this.__cleanedcache[ `n${node.id}` ];

		return node;
	}

	//Giving node and definitionId ( or definition itself ) will add metabackend corresponding attributes to the node
	//giving a definition node would return a node
	async addMetaAttributes( node, def ) {

		if( typeof( def ) === 'number' ) {
			//get definition from number
			let data = new Data();
			data.init( { uiPrefix: 'metabackend' } );
			this.setDomain( data );
            
			let result = null;
			let tree = await  data.getTreeAsync( def, true, 1 );
			if( tree.attributes ) result = this._addMetaAttributes( node, tree );
            
            
			return result;
		}
		else 
			return this._addMetaAttributes( node, def );
	}

	_addMetaAttributes( node, definition ) {
        
		//first of all, clear all the meta attributes, just to be sure
		this.clearMetaAttributes( node );
        
        
		//for each attribute add its corresponding meta attributes
		let atts = [];
		for ( var i = 0; i < node.attributes.length; i++ ) {
			let node_att = node.attributes[i];
			let def_att = definition.attributes.filter( d => d.typeId === node_att.typeId );
			if( def_att.length === 0 ) continue;
			def_att = def_att[0];
            
			//add att def id
			let att = new Attribute( { data: def_att.id, datatypeId: 9, idNode: node.id, typeId: 26, parentId: node_att.id, name: node_att.name } ).toJSON();
			atts.push( att );
			//add att rank. TODO: I don't know what is this, but all the values that i have saw was 1. Check with Ander to understand it
			att = new Attribute( { data: 1, datatypeId: 13, idNode: node.id, typeId: 26, parentId: node_att.id, name: node_att.name } ).toJSON();
			atts.push( att );
		}
        
		if( atts.length > 0 ) node.attributes = node.attributes.concat( atts );
        
		//add node def id attribute
		let att = new Attribute( { data: definition.id, datatypeId: 9, idNode: node.id, typeId: 26 } ).toJSON();
		node.attributes.push( att );
        
		//add node order
		att = new Attribute( { data: { order: 16127714149310 }, datatypeId: 25, idNode: node.id, typeId: 26 } ).toJSON();
		node.attributes.push( att );
        
		return node;
	}
}